import { IconButton } from '@mui/material';
import styled from 'styled-components';
import { ShowHideElementGridPart } from '../gridPartFactory/styles';

export const Container = styled(ShowHideElementGridPart)`
  display: flex;
  align-items: center;
  width: 100%;

  > .products-list__column {
    height: 100%;
    border-right: 1px solid #ebebeb;

    &:last-child {
      border: none;
    }
  }
`;

export const IconButtonCart = styled(IconButton)`
  &&& {
    width: fit-content;
    height: fit-content;

    &:disabled {
      color: rgb(0 0 0 / 30%);
    }
  }
`;

export const BoxButtonCart = styled(IconButton)`
  &&& {
    position: absolute !important;
    right: 0 !important;
    bottom: 0 !important;

    &:disabled {
      color: rgb(0 0 0 / 30%);
    }
  }
`;

